export default __webpack_public_path__ + "5af78691083d7b2391fbc90dd0719870.woff";